<template>
    <div class="col-xl-12 text-start">
        <div class="card">
            <div class="card-header">
                <h5 class="mb-0 p-0">
                    <button class="btn btn-link ps-0" data-bs-toggle="collapse" data-bs-target="#collapseicon1"
                        :aria-expanded="isActive ? 'true' : 'false'" aria-controls="collapseicon1"
                        :class="[isActive ? 'active' : '', 'collapsible']" v-on:click="toggle">Location</button>
                </h5>
            </div>
            <div :class="[isActive ? 'block' : 'none', 'content']" v-show="isActive">
                <div class="card-body animate-chk">
                    <div class="location-checkbox">
                        <label class="d-block" for="chk-ani6">
                            <input class="checkbox_animated" id="chk-ani6" type="checkbox">Letraset<span class="d-block">New
                                York, NY (399)</span>
                        </label>
                        <label class="d-block" for="chk-ani7">
                            <input class="checkbox_animated" id="chk-ani7" type="checkbox">Established<span
                                class="d-block">San Francisco, CA (252) </span>
                        </label>
                        <label class="d-block mb-0" for="chk-ani8">
                            <input class="checkbox_animated" id="chk-ani8" type="checkbox">Contrary<span
                                class="d-block">Washington, DC (226)</span>
                        </label>
                    </div>
                </div>
                <button class="btn btn-block btn-primary text-center" type="button">All Locations</button>
            </div>
        </div>
    </div>
    <jobTab2 />
</template>
<script >
import jobTab2 from "./jobTab2.vue"
export default {
    components: {
        jobTab2
    },
    data() {
        return {
            isActive: true,

        }
    },
    methods: {
        toggle() {
            this.isActive = !this.isActive
        },
    }
}
</script>